import { Component, OnDestroy } from '@angular/core';
// import { DoctorDashboardComponent } from '../doctors/doctor-dashboard/doctor-dashboard.component';
import { DoctorBreadcrumbService } from './breadcrumb.service';
import { Subscription } from 'rxjs';
import { MenuItem } from 'primeng/primeng';
import { TraceClassDecorator } from '@sentry/angular';

@TraceClassDecorator()
@Component({
    selector: 'doctor-app-breadcrumb',
    templateUrl: './app.breadcrumb.component.html'
})
export class DoctorAppBreadcrumbComponent implements OnDestroy {

    subscription: Subscription;

    items: MenuItem[];

    constructor(public breadcrumbService: DoctorBreadcrumbService) {
        this.subscription = breadcrumbService.itemsHandler.subscribe(response => {
            this.items = response;
        });
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
